import script from "./QuoteComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuoteComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuoteComponent.vue?vue&type=style&index=0&id=b3f23fa8&scoped=true&lang=css"

import exportComponent from "/var/www/html/laraccm2021/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f23fa8"]])

export default __exports__